import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AccountBean, ItemResponseAccountBeanObject } from "src/api/api";
import accountApi from "src/component/app/account/AccountApi";
import "src/component/app/sidebar/style.css";
import { StorageKey } from "./Storage";
import { TreeNodeNormal } from "antd/lib/tree/Tree";
import { User } from "src/context/UserContext";
import { env } from "../env";
import reportApi from "src/component/app/reports/ReportApi";

interface IabCategory {
  id: number;
  parentId: number;
  name: string;
  code: string;
}
export function truncateErrorMessage(message: string, maxLines: number = 5): any {
  if (!message) return message;
  const lines = message.split('\n').filter(Boolean);
  if (lines.length <= maxLines) return message;
  const shown = lines.slice(0, maxLines);
  const remaining = lines.length - maxLines;
  return shown.join('\n') + `\n...and ${remaining} more error(s)`;
}

export const DEALS_PAGE_SIZE = 10;
export const numberOrganizer = Intl.NumberFormat("en", {
  notation: "standard",
});

export const compactNumberFormatter = Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 2,
});

export type DealEnvironment = "WEB" | "APP" | "BOTH";

export function toDealEnvironment(selected: string[] | undefined | null): DealEnvironment | null {
  const values = Array.isArray(selected) ? selected.filter(Boolean) : [];
  const hasWeb = values.includes("WEB");
  const hasApp = values.includes("APP");

  if (!hasWeb && !hasApp) return null;
  if (hasWeb && hasApp) return "BOTH";
  return hasWeb ? "WEB" : "APP";
}

export const formatCompactNumber = (
  value: number,
  prefix = "",
  suffix = "",
  decimals = 2
): { short: string; full: string } => {
  const compact = compactNumberFormatter.format(value);
  const full = `${prefix}${numberOrganizer.format(Number(Math.abs(value).toFixed(decimals)))}${suffix}`;
  return { short: `${prefix}${compact}${suffix}`, full };
};
export const SellerType=[{label:"Publisher",value:"PUBLISHER"},{label:"Intermediary",value:"INTERMEDIARY"},{label:"Both",value:"BOTH"}]
export const RevenueCalculationMethod=[{label:"Wins",value:"WINS"},{label:"Impressions",value:"IMPRESSIONS"}]
export const FEE_CONFIG_DSP = [
  { mediaType: 'Banner', label: 'Display' },
  { mediaType: 'Video', label: 'Video' },
  { mediaType: 'CTV', label: 'CTV' }
]
export function downloadCSVData(fileName: string, csvData: Blob) {
  // @ts-ignore
  if (window.navigator.msSaveOrOpenBlob != undefined) {
    // IE hack see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    // @ts-ignore
    window.navigator.msSaveBlob(csvData, "filename.csv");
  } else {
    const a = window.document.createElement("a");
    a.href = URL.createObjectURL(csvData);
    a.download = fileName;
    document.body.appendChild(a);
    a.click(); // IE: "Access is denied" see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
    document.body.removeChild(a);
  }
}

export function menuItem(path: string, child: any, icon?: string) {
  return (
    <Link to={`/${path}`}>
      <span className="menuLeft__item-title">{child}</span>
      {icon && <span className={"icmn icmn-stats-bars" + " menuLeft__icon"} />}
    </Link>
  );
}

export function isAuthenticated() {
  if (localStorage.getItem(StorageKey.Authenticated) === "true") {
    let expirationString = localStorage.getItem(StorageKey.TokenExpiration);
    if (expirationString) {
      let expiration: number = +expirationString;
      if (expiration > Date.now()) {
        return true;
      }
    }
  }
  return false;
}

export function isAdmin(user) {
  return user?.role == AccountBean.RoleEnum.Admin;
}

export function isPublisher(user) {
  return user?.role == AccountBean.RoleEnum.Publisher;
}

export function isDsp(user) {
  return user?.role == AccountBean.RoleEnum.Dsp;
}

export function isReporting(user) {
  return user?.role == AccountBean.RoleEnum.Reporting;
}

export function isMenuItemAllowedForUser(user, menu) {
  const blockedMenuKeys: Array<string> =
    user?.role == AccountBean.RoleEnum.Admin
      ? ["dashboard"]
      : user?.role == AccountBean.RoleEnum.Publisher
      ? ["dashboards", "admin", "exchange", "raw-report", "reportDsp"]
      : user?.role == AccountBean.RoleEnum.Dsp
      ? ["dashboards", "admin", "exchange", "raw-report", "reportPublisher"]
      : ["dashboard", "admin", "exchange", "raw-report"];
  return !blockedMenuKeys.includes(menu?.key);
}

export async function setLoggedUserProps(setUser: (u: User) => void) {
  try {
    const item: ItemResponseAccountBeanObject = await accountApi.viewUser();
    if (item.data) {
      setUser({
        id: item.data.id ?? -1,
        username: item.data.username ?? "",
        role: item.data.role ?? undefined,
        publisherId: item.data.publisherId,
        dspId: item.data.dspId,
      });
    }
} catch (error) {
  console.error("Error fetching user data:", error);
}
}
export const handlegetTransactionStartDate = async (id:any)=>{
  const response = await reportApi.getTransactionStartDate(id).then((data:any)=> data.json())
  if(response?.data){
    localStorage.setItem(StorageKey.DisabledDate,response?.data)
  }
}
export function getTreeData(list: { name: string }[]) {
  let namesList: string[] = [];
  list.forEach((value) => namesList.push(value.name));
  let root: TreeNodeNormal[] = [];

  namesList.forEach((item, index) => {
    let groupName = item.split(" ")[0];
    let group = root.find(
      (node) => (node.key as string).localeCompare(groupName + "_group") == 0
    );

    if (group != undefined && group.children != undefined) {
      group.children.push({
        title: item,
        key: item,
      });
    } else {
      let itemNext = namesList[index + 1];

      if (itemNext != null) {
        let groupNameNext = namesList[index + 1].split(" ")[0];

        if (groupName.localeCompare(groupNameNext) == 0) {
          let newGroup: TreeNodeNormal = {
            title: groupName,
            key: groupName + "_group",
            children: [
              {
                title: item,
                key: item,
              },
            ],
          };
          root.push(newGroup);
        } else {
          root.push({
            title: item,
            key: item,
            children: [],
          });
        }
      }
    }
  });
  return root;
}

interface TreeSelectData {
  title: string;
  value: number;
  key: number;
  children?: TreeSelectData[];
}

export const SELECT_DEFAULTS_IAB_VALUE = -1;

export const NON_DEFAULT_IAB_PARENT_IDS = [25, 26];

export function getDefaultIabCategoryIds(list: IabCategory[]): number[] {
  return (list ?? [])
    .filter(
      (c) =>
        !NON_DEFAULT_IAB_PARENT_IDS.includes(c.id) &&
        !NON_DEFAULT_IAB_PARENT_IDS.includes(c.parentId)
    )
    .map((c) => c.id);
}

export function resolveIabDefaultsChange(
  value: number[] = [],
  previousValue: number[] = [],
  iabCategories: IabCategory[]
): number[] {
  const hasMarker = value.includes(SELECT_DEFAULTS_IAB_VALUE);
  const hadMarker = previousValue.includes(SELECT_DEFAULTS_IAB_VALUE);

  if (hasMarker && !hadMarker) {
    return [SELECT_DEFAULTS_IAB_VALUE, ...getDefaultIabCategoryIds(iabCategories)];
  }
  if (!hasMarker && hadMarker) {
    return [];
  }
  if (hasMarker) {
    const selected = new Set(value);
    const allDefaultsSelected = getDefaultIabCategoryIds(iabCategories).every((id) =>
      selected.has(id)
    );
    if (!allDefaultsSelected) {
      return value.filter((v) => v !== SELECT_DEFAULTS_IAB_VALUE);
    }
  }
  return value;
}

export function stripSelectDefaultsValue(ids: number[] = []): number[] {
  return (ids ?? []).filter((id) => id !== SELECT_DEFAULTS_IAB_VALUE);
}

export function getIabCategoriesAsTree(list: IabCategory[]) {
  let root: TreeSelectData[] = [];
  root.push({
    title: "Select defaults",
    key: SELECT_DEFAULTS_IAB_VALUE,
    value: SELECT_DEFAULTS_IAB_VALUE,
    children: [],
  });
  list
    .filter((v) => v.parentId == null)
    .forEach((v) =>
      root.push({
        title: v.name,
        key: v.id,
        value: v.id,
        children: [],
      })
    );
  list
    .filter((v) => v.parentId != null)
    .forEach((v) => {
      let group = root.find((item) => item.value === v.parentId);
      if (group != undefined && group.children != undefined) {
        group.children.push({
          title: v.name,
          key: v.id,
          value: v.id,
        });
      }
    });
  return root;
}

// export function getIabCategoriesAsTree(list: IabCategory[]) {
//     let root: TreeNodeNormal[] = []
//     list.filter(v => v.parentId == null)
//         .forEach(v => root.push({
//             title: v.name,
//             key: v.id,
//             children: []
//         }))
//     list.filter(v => v.parentId != null)
//         .forEach(v => {
//             let group = root.find(item => item.key === v.parentId)
//             if (group != undefined && group.children != undefined) {
//                 group.children.push({
//                     title: v.name,
//                     key: v.id,
//                 })
//             }
//         })
//     return root
// }

export function sorterFunc(getData: Function) {
  return (a, b) => {
    let dataA: any = getData(a) != null ? getData(a) : "";
    let dataB: any = getData(b) != null ? getData(b) : "";

    if (typeof dataA === "number" && typeof dataB === "number") {
      return dataA - dataB;
    } else {
      return dataA.localeCompare(dataB);
    }
  };
}

export function getFilterData(arr: {}[], getData: Function) {
  let filterData: { text: string; value: string }[] = [];
  arr.forEach((value) =>
    filterData.push({
      text:
        getData(value) === true
          ? "yes"
          : getData(value) === false
          ? "no"
          : getData(value),
      value: getData(value),
    })
  );
  return filterData.filter(
    (v, i, a) =>
      a.findIndex((t) => v.text === t.text && v.value === t.value) === i
  );
}

export function filterFunc(getData: Function) {
  return (value, record) => {
    return getData(record).toString().localeCompare(value) === 0;
  };
}

export function clone(obj) {
  var copy;

  // Handle the 3 simple types, and null or undefined
  if (null == obj || "object" != typeof obj) {
    return obj;
  }

  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }

  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = clone(obj[i]);
    }
    return copy;
  }

  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) {
        copy[attr] = clone(obj[attr]);
      }
    }
    return copy;
  }

  throw new Error("Unable to copy obj! Its type isn't supported.");
}

export function normalizeArrayFields(fieldNames: string[], form) {
  fieldNames.forEach((name) => {
    if (form.isFieldTouched(name)) {
      const value = form.getFieldValue(name);
      typeof value === "string" &&
        form.setFieldsValue({
          [name]: value.replace(/\s/g, "").replace(/,*$/, "").split(","),
        });
    }
  });
}

export function getParentId(
  childId: number,
  childList: any,
  parentField: Function
) {
  let finder = (entity) => entity.id === childId;
  let childItem = childList.find((item) => finder(item));
  return parentField(childItem);
}

export function useActionsMediaQuery(breakpoint: string) {
  const [areActionsVertical, setAreActionsVertical] = useState<boolean>(false);

  const handleActionsMediaQuery = useCallback((event) => {
    const isScreenNarrow = event.matches;
    setAreActionsVertical(isScreenNarrow);
  }, []);

  useEffect(() => {
    const actionsMediaQuery = window.matchMedia(`(max-width: ${breakpoint})`);
    if (actionsMediaQuery.matches) {
      setAreActionsVertical(true);
    }
    actionsMediaQuery.addListener(handleActionsMediaQuery);
    return () => {
      actionsMediaQuery.removeListener(handleActionsMediaQuery);
    };
  }, []);

  return areActionsVertical;
}

export const withActionsMediaQuery =
  (breakpoint: string) =>
  <T extends any>(WrappedComponent: React.ComponentType<T>): React.FC<T> =>
  (props: any) => {
    const [areActionsVertical, setAreActionsVertical] = useState(false);

    let actionsMediaQuery;

    useEffect(() => {
      const handleActionsMediaQuery = (event) => {
        const isScreenNarrow = event.matches;
        setAreActionsVertical(isScreenNarrow);
      };

      actionsMediaQuery = window.matchMedia(`(max-width: ${breakpoint})`);
      if (actionsMediaQuery.matches) {
        setAreActionsVertical(true);
      }
      actionsMediaQuery.addListener(handleActionsMediaQuery);

      return () => actionsMediaQuery.removeListener(handleActionsMediaQuery);
    }, []);

    return (
      <WrappedComponent {...props} areActionsVertical={areActionsVertical} />
    );
  };

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};

export enum DateOption {
  Day = "days",
  Week = "weeks",
  Month = "months",
  Year = "years",
}

// Define general type for useWindowSize hook, which includes width and height
export interface WindowSize {
  width: number | undefined;
  height: number | undefined;
}

// Hook
export function useWindowSize(): WindowSize {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    // Call handler right away so state gets updated with initial window size
    handleResize();
    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []); // Empty array ensures that effect is only run on mount
  return windowSize;
}

const dollarSymbolColumns: string[] = [
  "Spend (Net)",
  "Spend (Gross)",
  "eCPM",
  "Revenue",
  "Publisher Revenue",
];

export function addCommas(data: string) {
  return data.replace(/.+?(?=\D|$)/, function (f) {
    return f.replace(/(\d)(?=(?:\d\d\d)+$)/g, "$1,");
  });
}

export function roundBySlice(data: string) {
  if (env.rounding_revenue) {
    data = data.replace(/([\d,]+)([.])(\d+)/g, function (o, a, b, c) {
      return a + b + c.slice(0, 2);
    });
  }
  return data;
}

function addDollarAndRound(data: string) {
  if (!data || data.trim() === "") return data;
  data = "$ " + data;
  data = roundBySlice(data);
  return data;
}

export function beautifyReportData(
  header: string[] | undefined,
  data: string[][] | undefined
) {
  let dollar: number[] = [];
  for (let i = 0; header && i < header.length; i++) {
    if (dollarSymbolColumns.includes(header[i])) {
      dollar.push(i);
    }
  }

  for (let i = 0; data && i < data.length; i++) {
    for (let k = 0; k < data[i].length; k++) {
      data[i][k] = addCommas(data[i][k]);

      if (dollar.includes(k)) {
        data[i][k] = addDollarAndRound(data[i][k]);
      }
    }
  }
}

export const lowerize = (object) =>
  Object.keys(object).reduce((acc, k) => {
    const value = dollarSymbolColumns.includes(k)
      ? addDollarAndRound(object[k])
      : object[k];
    acc[k.toLowerCase()] = value;
    return acc;
  }, {});

  export type DateRange = {
    fromDate: string;
    toDate: string;
  };
  
  export const getLast7DaysRange = (): DateRange => {
    const today = new Date();
    const startOfLastWeek = new Date(today);
    startOfLastWeek.setDate(today.getDate() - 6);
  
    return {
        fromDate: startOfLastWeek.toISOString().split('T')[0], 
        toDate: today.toISOString().split('T')[0],             
    };
  };

  export function checkDateRange(startDate: any) {
    if (!startDate) {
      return "7D";
    }
      startDate = new Date(startDate);
        const endDate: Date = new Date();
  
    const calculateDateDifference = (start: Date, end: Date) => {
      let years = end.getFullYear() - start.getFullYear();
      let months = end.getMonth() - start.getMonth();
      let days = end.getDate() - start.getDate();
  
      if (days < 0) {
        months--;
        days += new Date(end.getFullYear(), end.getMonth(), 0).getDate(); 
      }
  
      if (months < 0) {
        years--;
        months += 12;
      }
  
      return { years, months, days };
    };
  
    const { years, months, days } = calculateDateDifference(startDate, endDate);
  
    if (years === 0 && months === 0 && days === 0) {
      return '1D';
    }
  
    if (years === 0 && months === 0 && days === 7) {
      return '7D';
    }
  
    if (years === 0 && months === 1 && days >= 0 && days <= 3) {
      return '1M';
    }
  
    if (years === 1 && months === 0 && days === 0) {
      return '1Y';
    }
  
    return 'Custom';
  }



